import { getFormattedDateString } from "../utils/getFormattedDateString";

export const searchResultCourseCard = (course) => {
    const searchLocale = window.jslocale?.search || {};
    const prefetchedLocale = window.jslocale?.prefetched || {};

    // desctructuring and default values for searchLocale
    const {
        from: courseDatePrefix = "ab",
        cost: courseCostPrefix = "Kursbeitrag",
        details: courseDetails = "Details",
    } = searchLocale;

    const { label_kurse } = prefetchedLocale;
    const {
        standort_name,
        sem_title,
        beginn_datum,
        sem_product_price,
        url_s,
        foerderung_name,
        green
    } = course;

    const startDate = getFormattedDateString(beginn_datum);

    const coursePrice = sem_product_price.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR",
    });

    let tags = "";

    if (foerderung_name?.length > 0) {
        foerderung_name.forEach((tag) => {
            tags += `<li class="tag"><span>${tag}</span></li>`;
        });
    }

    if (green?.length > 0) {
        if (green[0] == 1) {
            tags += `<li class="tag-green"><span>GREEN</span></li>`;
        }
    }

    const detailsButton = url_s
        ? `<div class="so-res-bottom"><a href="${url_s}" class="so-res-details-button" aria-label="${courseDetails}">${courseDetails}</a></div>`
        : '<div class="so-res-bottom no-button"></div>';

    return `
    <li class="so-course-result">
        <div class="so-res-top">
            <div class="so-res-course-type">${label_kurse}</div>
            <div class="so-res-location">
                <svg aria-hidden="true">
                    <use xlink:href="/images/frontend/main-icons.svg#map-icon"></use>
                </svg>
                <span>${standort_name}</span>
            </div>
        </div>
        <div class="so-res-mid">
            <h3 class="so-res-title">${sem_title}</h3>
            <div class="so-res-specs">
                <ul class="specs">
                    <li class="spec">
                        <svg aria-hidden="true">
                            <use xlink:href="/images/frontend/main-icons.svg#time-icon"></use>
                        </svg>
                        <span><em>${courseDatePrefix}:</em>${startDate}</span>
                    </li>
                    <li class="spec">
                        <svg aria-hidden="true">
                            <use xlink:href="/images/frontend/main-icons.svg#euro-icon"></use>
                        </svg>
                        <span><em>${courseCostPrefix}:</em>${coursePrice}</span>
                    </li>
                    ${tags}
                </ul>
            </div>
        </div>
        ${detailsButton}
    </li>`;
};
